import { HistoryOutlined } from '@ant-design/icons';
import { Button, Table } from 'antd';
import DownloadComponent from 'components/Global/Download';
import Ellipse from 'components/Global/Ellipse';
import { useSelector } from 'react-redux';
import { formatDate, invalidText } from 'utils/utils';
import EmployeeShareComponent from '../ToolTip';
import './index.scss';
const { Column } = Table;

type Props = {
	latestPayeDetails: any;
	isLoading: boolean;
	showModal: () => void;
	totalRecords: number;
};

const PayeLatestTable = (props: Props) => {
	const { latestPayeDetails, isLoading, showModal, totalRecords } = props;

	const { data: profileData } = useSelector(
		(state: any) => state?.userProfile
	);

	return (
		<div className="paye-table">
			<Table
				dataSource={latestPayeDetails}
				rowKey={(record) => record.id}
				loading={isLoading}
				pagination={false}
			>
				<Column
					title="Effective Date"
					dataIndex="effectiveDate"
					key="effectiveDate"
					className="bg-white"
					width={150}
					render={(value) => {
						return formatDate(
							value,
							profileData?.companyDateFormat ?? 'DD/MM/YYYY'
						);
					}}
				/>
				<Column
					title="Updated By"
					dataIndex="createdBy"
					key="createdBy"
					className="bg-white"
					width={150}
					render={(text) => text.fullName}
				/>

				<Column
					title="Attachment"
					dataIndex="attachment"
					key="attachment"
					className="bg-white"
					width={'18%'}
					render={(text, record: any) => (
						<div>
							{record.documentName ? (
								<div>
									<DownloadComponent
										documentUrl={record.documentUrl}
										showTooltip={true}
										downloadText={record.documentName}
										text={record.documentName}
										isLink={true}
										maxLength={20}
									/>
								</div>
							) : (
								'-'
							)}
						</div>
					)}
				/>
				<Column
					title="Employee Share"
					dataIndex="employeeShare"
					key="employeeShare"
					className="bg-white"
					width={150}
					render={(employeeShare) =>
						EmployeeShareComponent({ employeeShare })
					}
				/>
				{totalRecords >= 1 && (
					<Column
						title="History"
						dataIndex="history"
						key="history"
						className="bg-white"
						width={100}
						render={() => (
							<Button
								type="link"
								icon={<HistoryOutlined />}
								onClick={showModal}
							/>
						)}
					/>
				)}
			</Table>
		</div>
	);
};

export default PayeLatestTable;
